import Cookies from "js-cookie";

import AppController from "./AppController";
// import { AsyncDuckDB, AsyncDuckDBConnection } from "@duckdb/duckdb-wasm";

export type WasmHandler<S=any, E=any, D=any, Props=any, P=any>
  = (controller: WasmController<S, E, D, Props>, params?: P) => any

export default class WasmController<S, E, D, Props> extends AppController<S, E, Props> {

  python: any
  wasm: any
  data: D
  setProp: any
  cookies: typeof Cookies = Cookies
  apiToken: string
  permit: string
  mode: string
  history: any
  bearer?: any
  constructor(
    getState: () => S,
    setState: <K extends keyof S>(state: ((prevState: Readonly<S>, props: Readonly<Props>) => Pick<S, K> | S | null) | (Pick<S, K> | S | null), callback?: () => void ) => void,
    window: any,
    dataInitial: D,
    mode: string = "",
    history: any = null,
    bearer: any  = null,
  ) {
    super(getState, setState, window);
    this.data = dataInitial;
    this.apiToken = "";
    this.permit = "";
    this.mode = mode;
    this.history = history;
    this.bearer = bearer;
  }

  setData = (newData: D) => {
    this.data = {...this.data, ...newData};
  }

}